import React from "react";

const RecommendedTeachersSkeleton = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="h-6 w-64 bg-gray-200 mx-auto rounded animate-pulse mb-4" />
          <div className="h-4 w-96 bg-gray-100 mx-auto rounded animate-pulse" />
        </div>

        <div className="flex gap-6 overflow-x-auto">
          {[...Array(5)].map((_, idx) => (
            <div
              key={idx}
              className="min-w-[320px] md:min-w-[360px] flex-shrink-0"
            >
              <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 h-full flex flex-col animate-pulse">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="w-20 h-20 rounded-full bg-gray-200" />
                  <div className="flex-1 space-y-2">
                    <div className="h-4 w-32 bg-gray-300 rounded" />
                    <div className="h-3 w-20 bg-gray-200 rounded" />
                  </div>
                </div>

                <div className="h-3 w-full bg-gray-200 rounded mb-2" />
                <div className="h-3 w-5/6 bg-gray-200 rounded mb-2" />
                <div className="h-3 w-4/6 bg-gray-200 rounded mb-4" />

                <div className="space-y-2 mb-4">
                  <div className="h-3 w-3/4 bg-gray-100 rounded" />
                  <div className="h-3 w-1/2 bg-gray-100 rounded" />
                </div>

                <div className="h-8 w-28 bg-gray-300 rounded mt-auto" />
              </div>
            </div>
          ))}

          {/* Show More Placeholder */}
          <div className="min-w-[320px] md:min-w-[360px] flex-shrink-0 flex justify-center items-center border-2 border-dashed border-gray-300 rounded-2xl animate-pulse">
            <div className="flex flex-col items-center">
              <div className="h-6 w-6 bg-gray-300 rounded-full mb-2" />
              <div className="h-3 w-20 bg-gray-200 rounded" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecommendedTeachersSkeleton;
